<template>
  <div class="m-wrap br-lg px-16">
    <div class="df-col df-middle df-center" style="height: 64px">
      <t path="trade_38" class="f-md c-title">Today’s profit</t>
      <money :v="account.earnings"
        class="f-xxl f-bold mt-4"
        :class="{'c-success': account.earnings>=0,
        'c-danger': account.earnings<0}" />
    </div>
    <div class="df-between" style="height: 40px;border-top:1px solid var(--color-grey);">
      <div class="df-middle" :class="{'c-tip': demoState}" @click="linkToStyle">
        <Icon name="trading_style" />
        <t path="trade_40" class="ml-4">Trading style</t>
        <Icon name="caret-right" />
      </div>
      <div class="df-middle" :class="{'c-tip': demoState}" @click="linkToInfo">
        <Icon name="income" />
        <t path="trade_39" class="ml-4">Income Statement</t>
        <Icon name="caret-right" />
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { defineComponent, shallowRef, watch, computed } from 'vue'
import Icon from '@/components/Icon.vue'
import { isDemoAccount } from '@/state/accountType'
import router from '@/router'
import state from '@/state'

export default defineComponent({
  name: 'TheEarnings',
  components: {
    Icon,
  },
  setup () {
    const demoState = shallowRef(true)
    const account = computed(() => state.account)

    watch(() => isDemoAccount.value, () => {
      demoState.value = isDemoAccount.value
    }, {
      immediate: true,
    })

    const linkToInfo = () => {
      if (demoState.value) {
        return false
      }

      router.push('/trade/statement')
    }

    const linkToStyle = () => {
      if (demoState.value) {
        return false
      }

      router.push('/trade/tradeStyle')
    }

    return {
      demoState,
      account,
      linkToInfo,
      linkToStyle,
    }
  },
})
</script>

<style scoped lang='scss'>
.m-wrap{
  margin-top: 10px;
  background: var(--color-light);
}
</style>
